(() => {
  // Reuse the theme's variant selection and cart integration, including app properties.
  if (window.aldenoPdpForms) {
    window.aldenoPdpForms();
    return;
  }
  const init = () => {
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
      const buy = form.querySelector('[data-buy-now]');
      const add = form.querySelector('button[name="add"]');
      if (!buy || !add || form.dataset.aldenoPurchaseBound) return;
      form.dataset.aldenoPurchaseBound = 'true';
      let busy = false;
      const unavailable = () => add.disabled || add.getAttribute('aria-disabled') === 'true';
      const sync = () => {
        buy.disabled = busy || unavailable();
        buy.setAttribute('aria-disabled', String(buy.disabled));
        const label = buy.querySelector('.t4s-btn-atc_text');
        if (label) label.textContent = add.disabled
          ? (add.querySelector('.t4s-btn-atc_text')?.textContent.trim() || 'Unavailable')
          : 'Buy Now';
      };
      // Kalles updates this button on variant changes; Buy Now must follow the same state.
      new MutationObserver(sync).observe(add, {
        attributes: true, attributeFilter: ['disabled', 'aria-disabled']
      });
      sync();
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        busy = false;
        sync();
        buy.removeAttribute('aria-busy');
        const spinner = buy.querySelector('.t4s-loading__spinner');
        const label = buy.querySelector('.t4s-btn-atc_text');
        if (spinner) spinner.hidden = true;
        if (label) label.style.visibility = '';
      });

      const valid = () => !unavailable() && form.reportValidity();
      form.addEventListener('click', event => {
        if (!event.target.closest('button[name="add"]')) return;
        if (busy || !valid()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      form.addEventListener('submit', event => {
        if (busy || !valid()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);

      buy.addEventListener('click', async event => {
        event.preventDefault();
        if (busy || !valid()) return;
        busy = true;
        sync();
        buy.setAttribute('aria-busy', 'true');
        const spinner = buy.querySelector('.t4s-loading__spinner');
        const label = buy.querySelector('.t4s-btn-atc_text');
        if (spinner) spinner.hidden = false;
        if (label) label.style.visibility = 'hidden';
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this product. Please try again.');
          window.location.assign(root + 'checkout');
        } catch (error) {
          busy = false;
          sync();
          buy.removeAttribute('aria-busy');
          if (spinner) spinner.hidden = true;
          if (label) label.style.visibility = '';
          window.alert(error.message || 'Something went wrong. Please try again.');
        }
      });
    });
  };
  window.aldenoPdpForms = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
